import { DIALOG_INACTIVE, LOADING_INACTIVE, SNACKBAR_INACTIVE } from "constants/actions";
import {
    clearSessionExpiredActive,
    registerSessionExpiredHandler,
    unregisterSessionExpiredHandler
} from "core/sessionExpiry";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

const SessionExpiryHandler = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        registerSessionExpiredHandler(() => {
            // Clear loading spinner, any open dialog, and any snackbar that raced in
            dispatch({ type: LOADING_INACTIVE });
            dispatch({ type: DIALOG_INACTIVE });
            dispatch({ type: SNACKBAR_INACTIVE });
            // Deferred suppression for snackbars dispatched by catch blocks after the rejection propagates
            setTimeout(() => dispatch({ type: SNACKBAR_INACTIVE }), 0);
            setVisible(true);
        });

        return () => {
            unregisterSessionExpiredHandler();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClose = () => {
        setVisible(false);
        clearSessionExpiredActive();
        localStorage.clear();
        navigate("/signin");
    };

    if (!visible) return null;

    return (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-20 z-[200] flex justify-center animate-fade-in-down">
            <div className="self-center bg-white rounded-main w-1/2 sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 flex flex-col">
                <div className="flex justify-center w-full py-2 text-white bg-error-dark rounded-t-main">
                    Perhatian
                </div>
                <div className="text-center px-16 py-5">
                    Sesi Anda Telah Berakhir, Silahkan Login Kembali
                </div>
                <div className="flex justify-start w-full py-5 px-16">
                    <button
                        className="bg-grey-100 hover:bg-grey-200 text-primary-main py-2 w-full"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiryHandler;
